module.exports = __webpack_public_path__ + "media/s6Model4.0d13b247.mp4";